import React from "react";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import axios from "axios";
import config from "../config";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import history from '../history.js'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.css";

const optionToast = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleChangeEditName = this.handleChangeEditName.bind(this);
    this.handleChangeEditPhone = this.handleChangeEditPhone.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this);
    this.handleChangeConfirmPassword =
      this.handleChangeConfirmPassword.bind(this);

    this.state = {
      email: "",
      name: "",
      tel: "",
      enable: false,
      editModal: false,
      modal: false,
      valid: false,
      alert: "",
      checkmatch: "",
      editName: "",
      editTel: "",
      password: "",
      newpassword: "",
      confirmpassword: "",
      unmountOnClose: true,
    };
  }

  componentDidMount = () => {
    this.feedAccount();
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      password: "",
      newpassword: "",
      confirmpassword: "",
      alert: "",
      checkmatch: "",
    });
  };

  toggleEdit = () => {
    const next = !this.state.editModal;
    this.setState({
      editModal: next,
      editName: next ? this.state.name || "" : this.state.editName,
      editTel: next ? this.state.tel || "" : this.state.editTel,
    });
  };

  handleChangeName(event) {
    this.setState({
      name: event.target.value,
    });
  }

  handleChangePhone(event) {
    this.setState({
      tel: event.target.value,
    });
  }

  handleChangeEditName(event) {
    this.setState({ editName: event.target.value });
  }

  handleChangeEditPhone(event) {
    this.setState({ editTel: event.target.value });
  }

  handleChangePassword(event) {
    this.setState({
      password: event.target.value,
    });
  }

  handleChangeNewPassword(event) {
    this.setState({
      newpassword: event.target.value,
    });
  }

  handleChangeConfirmPassword(event) {
    this.setState({
      confirmpassword: event.target.value,
    });
  }

  feedAccount = () => {
    axios
      .post(config.host + "/api/v1/account", {
        id: localStorage.StudioUserID,
      })
      .then((res) => {
        console.log(res.data);
        const account = res.data.result[0];
        const enable =
          account.enable === true ||
          account.enable === "true" ||
          account.enable === 1 ||
          account.enable === "1";

        this.setState({
          email: account.email,
          tel: account.phone,
          name: account.fullname,
          enable,
        });
      })
      .catch((err) => {});
  };

  Update = () => {
    axios
      .post(config.host + "/api/v1/account/update", {
        id: localStorage.StudioUserID,
        fullname: this.state.editName,
        phone: this.state.editTel,
      })
      .then((res) => {
        if (res.data.status === "success") {
          toast.success("Update account successfully !", optionToast);
          this.setState({
            name: this.state.editName,
            tel: this.state.editTel,
            editModal: false,
          });
        }
      })
      .catch((err) => {});
  };

  ChangePassword = () => {
    // confrim password
    if (this.state.newpassword !== this.state.confirmpassword) {
      this.setState({
        checkmatch: "Password do not match !",
      });
    } else {
      this.setState({
        checkmatch: "",
      });
      axios
        .post(config.host + "/api/v1/account/password", {
          id: localStorage.StudioUserID,
          oldpassword: this.state.password,
          newpassword: this.state.newpassword,
        })
        .then((res) => {
          if (res.data.status === "error") {
            this.setState({
              alert: "OldPassword is wrong !",
            });
          } else {
            toast.success("Update password successfully !", optionToast);
            this.setState({
              alert: "",
              modal: !this.state.modal,
            });
          }
        })
        .catch((err) => {});
    }
  };

  render() {
    return (
      <>
        <div className="app-shell">
          <Navbar />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
          />

          <main className="app-main">
            <div className="profile-page">
              <div className="profile-card">
                <div className="profile-card__header">
                  <div>
                    <h3 className="profile-card__title">Profile</h3>
                    <p className="profile-card__subtitle">
                      Manage your account information
                    </p>
                  </div>
                  <span
                    className={`profile-status-badge ${
                      this.state.enable
                        ? "profile-status-badge--active"
                        : "profile-status-badge--suspended"
                    }`}
                  >
                    {this.state.enable ? "Active" : "Suspended"}
                  </span>
                </div>
                <div className="profile-card__body">
                  <div className="profile-field">
                    <label className="profile-label">Username</label>
                    <input
                      type="email"
                      className="profile-input"
                      id="email"
                      placeholder="Enter email"
                      value={this.state.email}
                      disabled
                    />
                  </div>
                  <div className="profile-field">
                    <label className="profile-label">Full name</label>
                    <input
                      type="text"
                      className="profile-input"
                      placeholder="Enter your full name"
                      value={this.state.name}
                      disabled
                    />
                  </div>
                  <div className="profile-field">
                    <label className="profile-label">Telephone</label>
                    <input
                      type="text"
                      className="profile-input"
                      placeholder="Enter your telephone number"
                      value={this.state.tel}
                      disabled
                    />
                  </div>

                  <div className="profile-actions">
                    <button
                      type="button"
                      className="profile-btn profile-btn--primary"
                      onClick={this.toggleEdit}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      className="profile-btn profile-btn--ghost"
                      onClick={this.toggle}
                    >
                      Change Password
                    </button>
                  </div>
                </div>
              </div>

              <div>
                <Modal
                  isOpen={this.state.editModal}
                  toggle={this.toggleEdit}
                  centered
                  backdrop="static"
                  className="profile-modal"
                  contentClassName="profile-modal__content"
                >
                  <ModalHeader
                    toggle={this.toggleEdit}
                    className="profile-modal__header"
                  >
                    Edit Profile
                  </ModalHeader>
                  <ModalBody className="profile-modal__body">
                    <div className="profile-field">
                      <label className="profile-label">Full name</label>
                      <input
                        type="text"
                        className="profile-input"
                        placeholder="Enter your full name"
                        value={this.state.editName}
                        onChange={this.handleChangeEditName}
                      />
                    </div>
                    <div className="profile-field">
                      <label className="profile-label">Telephone</label>
                      <input
                        type="text"
                        className="profile-input"
                        placeholder="Enter your telephone number"
                        value={this.state.editTel}
                        onChange={this.handleChangeEditPhone}
                      />
                    </div>
                  </ModalBody>
                  <ModalFooter className="profile-modal__footer">
                    <button
                      type="button"
                      className="profile-btn profile-btn--ghost"
                      onClick={this.toggleEdit}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="profile-btn profile-btn--primary"
                      onClick={this.Update}
                      disabled={!this.state.editName || !this.state.editTel}
                    >
                      Update
                    </button>
                  </ModalFooter>
                </Modal>

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  centered
                  backdrop="static"
                  className="profile-modal"
                  contentClassName="profile-modal__content"
                >
                  <ModalHeader
                    toggle={this.toggle}
                    className="profile-modal__header"
                  >
                    Change Password
                  </ModalHeader>
                  <ModalBody className="profile-modal__body">
                    <div className="profile-field">
                      <label className="profile-label">Old Password</label>
                      <input
                        type="password"
                        className="profile-input"
                        placeholder="Enter your old password"
                        value={this.state.password}
                        onChange={this.handleChangePassword}
                      />
                      {!!this.state.alert && (
                        <div className="profile-hint profile-hint--error">
                          {this.state.alert}
                        </div>
                      )}
                    </div>
                    <div className="profile-field">
                      <label className="profile-label">New Password</label>
                      <input
                        type="password"
                        className="profile-input"
                        placeholder="New password"
                        value={this.state.newpassword}
                        onChange={this.handleChangeNewPassword}
                      />
                    </div>
                    <div className="profile-field">
                      <label className="profile-label">
                        Confirm New Password
                      </label>
                      <input
                        type="password"
                        className="profile-input"
                        placeholder="Confirm password"
                        value={this.state.confirmpassword}
                        onChange={this.handleChangeConfirmPassword}
                      />
                      {!!this.state.checkmatch && (
                        <div className="profile-hint profile-hint--error">
                          {this.state.checkmatch}
                        </div>
                      )}
                    </div>
                  </ModalBody>
                  <ModalFooter className="profile-modal__footer">
                    <button
                      type="button"
                      className="profile-btn profile-btn--ghost"
                      onClick={this.toggle}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="profile-btn profile-btn--primary"
                      onClick={this.ChangePassword}
                      disabled={
                        !this.state.password ||
                        !this.state.newpassword ||
                        !this.state.confirmpassword
                      }
                    >
                      Update
                    </button>
                  </ModalFooter>
                </Modal>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </>
    );
  }
}

export default Profile;
